import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject } from 'Douleutaras/types';
import { makeRequest } from 'Douleutaras/services/apiClient';

const BONUS_PAGE_API = 'api/public/v3/pro-monthly-bonus-summary';

export interface BonusPageProps {
  month: string;
  monthlyBonus: number; // e.g., 100
  // Progress
  jobsStartedActual: number; // e.g., 15
  jobsStartedTarget: number; // e.g., 20
  jobsStartedDifference: number;
  // Upsell / callouts
  revenueTarget: number; // e.g., 125 (euros) — only shows in in-progress state
  revenueActual: number; // e.g., 50 (euros)
  revenueDifference: number;
  // Overview
  redeemableBonus: number; // e.g., 85
  lifetimeRedeemedBonus: number; // e.g., 615
  // Targets achieved
  jobsTargetsAchieved: boolean;
  revenueTargetsAchieved: boolean;
  // Bonus eligibility flag
  isEligibleForBonus: boolean;
}

export interface BonusPageSliceModel {
  loading: boolean;
  data: JSONApiDataObject<BonusPageProps>;
}

export const getBonusPage = createAsyncThunk<JSONApiDataObject<BonusPageProps>>(
  'bonusPage/get',
  async (args, api) => {
    const response = await makeRequest(
      `${BONUS_PAGE_API}/`,
      {
        method: 'GET'
      }
    )(api);

    return response.data.data;
  }
);

export const bonusPageSlice = createSlice({
  name: 'bonusPage',
  initialState: {
    loading: false,
    data: {}
  } as BonusPageSliceModel,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getBonusPage.pending, state => {
      state.loading = true;
    });
    builder.addCase(getBonusPage.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(getBonusPage.rejected, state => {
      state.loading = false;
    });
  }
});
